var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-select", class: { "c-select--small": _vm.small } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-select__arrow" },
        [
          _c("font-awesome-icon", {
            staticClass: "h-4 w-4",
            attrs: { icon: _vm.faAngleDown }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }